import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import GoogleMapsLoader from 'google-maps';

class Map extends Component {
  componentDidMount = () => {
    this.createMap();
  };
  createMap = () => {
    var position = {lat: parseFloat(this.props.lat), lng: parseFloat(this.props.lng)};
    const options = {
       center: position,
       zoom: 12,
       disableDefaultUI: true,
       scrollwheel: false
    };
    GoogleMapsLoader.KEY = process.env.REACT_APP_googleApiKey;
    GoogleMapsLoader.load((google=>{
      var newMap = new google.maps.Map(this.refs.map, options);
      var marker = new google.maps.Marker({
          map: newMap,
          position: position
      });
      marker.setMap(newMap);
    }));
  };
  render () {
    return (
      <div ref="map" style={styles.map}></div>
     );
  }
}

var styles = {
  map:{
    width: '100%',
    height: '250px',
    frameBorder: "0",
    border: '0'
  }
}
   Map.propTypes = {
    lat: PropTypes.string.isRequired,
    lng: PropTypes.string.isRequired
  };
export default Radium(Map);


// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/ProjectCard/map.jsx